import { createFileRoute } from '@tanstack/react-router';
import { OrganizationPage } from '@/features/tenant-admin/pages';

export const Route = createFileRoute('/tenant-admin/organization')({
    component: OrganizationPage,
});
